import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import '@/i18n/i18n';

import { env } from '@/config/env';
import { IframeResizer } from '@/containers/IframeResizer/IframeResizer';
import { setupStore } from '@/store';

import { ChakraProvider } from '@/providers/ChakraProvider';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const store = setupStore();

Sentry.init({
  dsn: env.GLITCH_TIP_DSN,
  environment:
    import.meta.env.MODE === 'production' ? 'production' : 'development',
});

root.render(
  <>
    <IframeResizer />

    <Provider store={store}>
      <ChakraProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </Provider>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
